import memoize from "lodash/memoize";
import { getCurrencySymbol, localizer } from "./currency-localizer/localizer.js";
import { abbreviateNumber } from "./number.js";
export const priceIsZero = (price) => price.units === 0 && price.nanos === 0;
const NumberFormatMemoized = memoize(Intl.NumberFormat, (locale, options) => String(locale) + String(options?.currency) + String(options?.maximumFractionDigits));
export const priceToValue = ({ nanos, units }) => {
    const sign = Math.sign(units !== 0 ? units : nanos) || 1;
    const normalizedNanos = sign * Math.abs(nanos / 1e9);
    return units + normalizedNanos;
};
export const formatPrice = (price, locale, formatOptions) => {
    let value = priceToValue(price);
    if (formatOptions?.isDiscount) {
        value = 0 - value;
    }
    if (formatOptions?.useNativeFormatting) {
        return NumberFormatMemoized(locale, {
            style: "currency",
            currency: price.currencyCode,
            maximumFractionDigits: formatOptions?.decimalPlaces
        }).format(value);
    }
    return localizer(value, {
        currency: price.currencyCode,
        locale,
        decimalPlaces: formatOptions?.decimalPlaces
    });
};
export const formatAbbreviatedPrice = (price, locale, preferredMaxLength = 5) => {
    const value = priceToValue(price);
    const currencySymbol = getCurrencySymbol(price.currencyCode);
    const formattedPrice = formatPrice(price, locale);
    if (value < 1000)
        return formattedPrice;
    let digits = 2;
    let abbreviatedValue = abbreviateNumber(value, digits, locale);
    while (abbreviatedValue.length > preferredMaxLength && digits > 0) {
        digits -= 1;
        abbreviatedValue = abbreviateNumber(value, digits, locale);
    }
    const separator = formattedPrice.includes(" ") ? " " : "";
    const currencyInFront = formattedPrice.startsWith(currencySymbol);
    const parts = [currencySymbol, abbreviatedValue.toUpperCase()];
    if (!currencyInFront)
        parts.reverse();
    return parts.join(separator);
};
